import { api } from '@/lib/api/client';
import type { XkStock } from '@/lib/api/types';

/**
 * PRD §9 v2 — Per-event eligible-prize pool. Curated subset of a brand's
 * adopted prizes that stations under this event are allowed to allocate.
 *
 * Backend routes (ox-platform):
 *   GET /xk-event-prize-pool?eventId=:id   → list pool entries for an event
 *   PUT /xk-event-prize-pool/event/:id     → upsert full pool from stockIds[]
 */

export interface XkEventPrizePool {
  id: number;
  eventId: number;
  stockId: number;
  status: 'Enable' | 'Disable' | 'Deleted';
  createdAt?: string;
  updatedAt?: string;
  // Eagerly joined by `listByEvent` so the FE renders names/images without
  // a follow-up stock fetch.
  stock?: XkStock;
}

export const eventPrizePoolApi = {
  /**
   * Returns ALL pool rows for an event (Enabled + Disabled). The picker UI
   * filters client-side because rendering history of "previously enabled"
   * is useful for the operator.
   */
  list: (eventId: number) =>
    api.list<XkEventPrizePool>('/xk-event-prize-pool', {
      filter: { eventId },
    }),

  /**
   * Upsert the full pool for an event. Stocks present in `stockIds` are
   * Enabled (rows created if missing). Stocks absent are flipped to
   * status=Disable. Preserves history.
   */
  upsert: (eventId: number, stockIds: number[]) =>
    api.put<XkEventPrizePool[]>(
      `/xk-event-prize-pool/event/${eventId}`,
      { stockIds },
    ),
};
